import axios, { AxiosError } from "axios";

export function handleAxiosError(error: unknown | AxiosError) {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      if (error.response.data.name === "TokenExpiredError") {
        window.location.reload();
      }
    }
  }
}
